import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { uniqueId } from './lib/helpers';
import { SearchResult, SearchService } from './search.service';
import { FilterService } from './filter.service';
import { BreadCrumbsService } from './breadcrumbs.service';
import { CatalogService } from './catalog/catalog.service';
import { NavigationEnd, Router } from '@angular/router';
import { SubscriptionLike } from 'rxjs';
import {SearchComponent} from './search.component';

@Component({
  selector: 'app-search-with-basket',
  templateUrl: '../templates/search-with-basket.component.html',
  styleUrls: ['../styles/components/search.component.less']
})
export class SearchWithBasketComponent extends SearchComponent {

}
